import { createHttpMutationAdapter } from '@/lib/adapters/httpMutationAdapter';

export const httpPutAdapter = createHttpMutationAdapter('put');
